const CategoryArticlesSkeleton = () => {
  return (
    <div>
      {/* ✅ Skeleton pour la catégorie */}
      <div className="mb-6 text-center">
        <div className="mx-auto h-8 w-48 animate-pulse rounded bg-gray-300 dark:bg-gray-700"></div>
        <div className="mx-auto mt-2 h-4 w-64 animate-pulse rounded bg-gray-300 dark:bg-gray-700"></div>
      </div>

      {/* ✅ Skeleton pour les articles */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(9)].map((_, index) => (
          <div key={index} className="block rounded-lg border p-4 shadow">
            <div className="h-48 w-full animate-pulse rounded-lg bg-gray-300 dark:bg-gray-700"></div>
            <div className="mt-3 h-6 w-3/4 animate-pulse rounded bg-gray-300 dark:bg-gray-700"></div>
            <div className="mt-2 h-4 w-1/2 animate-pulse rounded bg-gray-300 dark:bg-gray-700"></div>
          </div>
        ))}
      </div>

      {/* ✅ Skeleton pour la pagination */}
      <div className="mt-8 flex flex-col items-center space-y-2">
        <div className="h-4 w-24 animate-pulse rounded bg-gray-300 dark:bg-gray-700"></div>
        <div className="h-10 w-64 animate-pulse rounded bg-gray-300 dark:bg-gray-700"></div>
      </div>
    </div>
  );
};

export default CategoryArticlesSkeleton;
